import React from 'react';

import { TooltipWrapper } from './styles';

export interface Props {
  message: string;
  isShowing?: boolean;
  bottomPos?: number;
  position?: string;
}

const Tooltip = ({ message, isShowing = true, bottomPos = 0, position = 'bottom' }: Props) => {
  return (
    <TooltipWrapper isShowing={isShowing} bottomPos={bottomPos} position={position}>
      {message}
    </TooltipWrapper>
  );
};

export default Tooltip;
